import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const FamiliesPerIndigenousReservation = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Famílias por Reserva Indígena'}
            horizontal={false}
            subtitles={chartData?.familiesPerIndigenousReservation?.map((item) => item.description)}
            values={chartData?.familiesPerIndigenousReservation?.map((item) => item.total  ||  0)}
        />
    );
};
